import { render, staticRenderFns } from "./IntegrarItens.vue?vue&type=template&id=59591189&scoped=true"
import script from "./IntegrarItens.vue?vue&type=script&lang=js"
export * from "./IntegrarItens.vue?vue&type=script&lang=js"
import style0 from "./IntegrarItens.vue?vue&type=style&index=0&id=59591189&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59591189",
  null
  
)

export default component.exports